import { Fetcher } from '@Types/fetcher'
import useBaseFetcher from '../base'

const shopDetailsQuery = `
  query getShop {
    shop {
      id
      name
      email
      billingAddress {
        country
        countryCodeV2
      }
      currencyCode
      plan {
        displayName
      }
      myshopifyDomain
    }
  }
`

function useShopDetails(): Fetcher {
  const [baseFetcher, meta] = useBaseFetcher()

  const shopDetailsFetcher = async () => {
    return await baseFetcher('shopify:admin/api/graphql.json', {
      method: 'POST',
      body: JSON.stringify({
        query: shopDetailsQuery,
      }),
    })
  }

  return [shopDetailsFetcher, meta]
}

export default useShopDetails
